// ============================================================================
// STORAGE KEYS — Single Source of Truth
// ============================================================================
// All localStorage keys used throughout the application.
// Every localStorage access MUST use these constants. Zero magic strings.

export const STORAGE_KEYS = {
  // Tokens
  ACCESS_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',

  // Tenant context
  TENANT_ID: 'tenant_id',
  TENANT_NAME: 'tenant_name',
  TENANT_DISPLAY_NAME: 'tenant_display_name',
  TENANT_LOGO: 'tenant_logo',
  APP_ID: 'app_id',
  USER_ID: 'user_id',

  // User info
  USER_NAME: 'user_name',
  USER_EMAIL: 'user_email',
  USER_FIRST_NAME: 'user_first_name',
  USER_LAST_NAME: 'user_last_name',
  FULL_NAME: 'full_name',
  USER_ROLE: 'user_role',

  // Permissions
  PERMISSIONS: 'permission_context',
  SCOPE_CONFIG: 'scope_configuration',

  // Scope selections
  SELECTED_ENTITY_ID: 'selected_entity_id',
  SELECTED_ENTITY_NAME: 'selected_entity_name',
  SELECTED_BU_ID: 'selected_bu_id',
  SELECTED_BU_NAME: 'selected_bu_name',
  SELECTED_FY_ID: 'selected_fy_id',
  SELECTED_FY_NAME: 'selected_fy_name',
  SELECTED_FY_CODE: 'selected_fy_code',

  // App state
  NAVIGATION_MENU: 'NAVIGATION_MENU',
  MODULES_CONFIG: 'MODULES_CONFIG',
  USER: 'user',
  /** DineOps multi-outlet: the outlet chosen at sign-in, sent as X-Outlet-ID on /dine calls. */
  DINE_OUTLET_ID: 'dine_outlet_id',
  DINE_OUTLET_NAME: 'dine_outlet_name',
  APP_CONFIG: 'APP_CONFIG',
  /** Paint hint for the header Entity/BU and FY selectors (useLayoutPreferences, template port). */
  LAYOUT_PREFERENCES: 'APP_LAYOUT_PREFERENCES',

  // Auth mode
  AUTH_MODE: 'auth_mode',

  // RBAC — populated at login from /api/v1/RolePermissions/by-roles. Used as
  // a lightweight permission cache so reloading the page does not require a
  // network round-trip before the sidebar can be rendered.
  RBAC_ROLES: 'rbac_roles',
  RBAC_VISIBLE_MODULES: 'rbac_visible_modules',
  RBAC_MODULE_ACTIONS: 'rbac_module_actions',

  // DB-driven role catalog — fetched at app boot from
  // /api/v1/RolePermissions/known-roles and cached here (with a companion
  // fetched-at timestamp) so resolveHighestPriorityRole and the login-page
  // error message stay accurate for any role added via the admin UI without
  // needing a code deploy. 15-minute TTL; refreshed on cache expiry or 401.
  KNOWN_ROLES: 'known_roles',
  KNOWN_ROLES_FETCHED_AT: 'known_roles_fetched_at',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
